<template>
<form class="form main__form">
	<div class="inner">
		<div
		class="form__area"
		v-for="question, i in currentQuestions"
		:key="question.id"
		:class="{'is-last': i+1 === currentQuestions.length}">
			<h2 class="form__tit" v-if="question.title">
				<span class="form__num">{{ surveyNum }}</span>
				{{ question.title }}
			</h2>
			<h3 class="form__subtit" v-if="question.subtitle">
				{{ question.subtitle }}
			</h3>

			<!-- 星5段階評価 -->
			<div class="form__row is-star" v-if="question.type === 'rating'">
				<div class="form__star-wrap">
					<star-rating
					v-model:rating="questions[question.id].result"
					:show-rating="false"
					:star-size="40"
					inactive-color="#fff"
					active-color="#FFE600"
					></star-rating>
				</div>
				<p class="form__note">1～5段階でご評価ください。</p>
			</div>

			<!-- 多段階評価 -->
			<div class="form__row" v-if="question.type === 'nps'">
				<div class="form__nps-legend">
					<span>低い</span>
					<span>高い</span>
				</div>
				<div class="form__nps-wrap">
					<template v-for="n in question.options+1" :key="n-1">
						<label :for="`nps${n-1}`" :class="{'is-active': questions[question.id].result === n-1+''}">{{n-1}}</label>
						<input :id="`nps${n-1}`" type="radio" v-model="questions[question.id].result" :value="n-1+''">
					</template>
				</div>
				<p class="form__note">0～{{question.options}}段階でご評価ください。</p>
			</div>

			<!-- ラジオボタン -->
			<div class="form__row" v-if="question.type === 'radio'">
				<div class="form__radio-wrap" v-for="(option, i) in question.options" :key="`option${i}`">
					<label :for="`option${i}`" :class="{'is-active': questions[question.id].result === option.val}">{{ option.val }}</label>

					<!-- テキストボックスなし -->
					<template v-if="option.textbox === undefined">
						<input :id="`option${i}`" type="radio" v-model="questions[question.id].result" :value="option.val">
					</template>

					<!-- テキストボックスあり -->
					<template v-else>
						<!-- ラジオボタン -->
						<input
						:id="`option${i}`"
						type="radio"
						v-model="questions[question.id].result"
						:value="option.val"
						@click="connectText($event, `option${i}-text`);">
						<!-- テキストボックス -->
						<textarea
						:id="`option${i}-text`"
						type="text"
						v-model="option.textbox"
						@click="connectText($event, `option${i}`, questions[question.id]);"
						rows="8"
						placeholder="150字以内でご入力ください"></textarea>
					</template>
				</div>
			</div>

			<!-- セレクトボックス -->
			<div class="form__row" v-if="question.type === 'select'">
				<div class="form__select-wrap">
					<select v-model="questions[question.id].result" >
						<option value="" selected>選択してください</option>
						<option v-for="(option, i) in question.options" :key="`option${i}`" :value="option.val">{{ option.val }}</option>
					</select>
				</div>
			</div>

			<!-- エラー表示 -->
			<ul v-if="errors[question.id]" class="form__error-list">
				<Btn v-for="error, i in errors[question.id]" :key="`error${i}`" tag="li" class="is-error form__error-item">{{ error }}</Btn>
			</ul>
		</div>
		
		<!-- ボタン -->
		<div class="form__btnarea">
			<Btn class="is-prev" @click="back" v-if="currentPage != 'nps_rating'">前へ</Btn>
			<Btn class="is-next" @click="next" v-if="!isLastPage">次へ</Btn>
			<Btn class="is-next" @click="next" v-if="isLastPage">送信</Btn>
		</div>
	</div>

</form>
</template>

<script>
import StarRating from 'vue-star-rating';
import Btn from '../components/Btn.vue';

export default {
	components: {
		StarRating,
		Btn,
	},

	data() {
		return {
			/**
             * アンケートデータを格納
			 * @type {array[object]}
			 * 
             * @prop {string} id アンケートID
			 * アンケートオブジェクトのプロパティの文字列がcreated時に自動的に付与されます。
			 * 
             * @prop {string} title 質問の内容（必須）
			 * 
             * @prop {string} subtitle サブタイトル
			 * 
             * @prop {string} progress アンケートの進行率の概算（必須）
			 * 「回答率」の欄に表示します。
			 * 
             * @prop {string} type アンケートのタイプ（必須）
			 * 'rating': 星5段階評価
			 * 'nps': 数字多段階評価
			 * 'radio': ラジオボタン
			 * 'select': セレクトボックス
             * 
             * @prop {boolean} randomize アンケートの選択肢をランダムに表示（radio, selectのみ）
			 * 
             * @prop {number | array[object]} options アンケートの選択肢
			 * typeがnpsの場合は数値、radio, selectの場合は配列の中にオブジェクトで記入してください（必須）。
			 * radingの場合は記入しないでください。
             * 
			 * @prop {string} options[n].val アンケートの選択肢の文言（radio, selectのみ、必須）
			 * 
			 * @prop {string} options[n].jump
			 * 選択肢によって遷移先を分岐したい場合はアンケートIDを記入してください。（radio, selectのみ）
			 * 直下のjumpより優先されます。
			 * 
			 * @prop {string} options[n].textbox
			 * 選択肢と一緒にテキストボックスを出します。（radioのみ）
			 * 値はv-modelでバインドされます。
			 * 
			 * @prop {boolean} options[n].excludeRandomize ランダマイズしない (radio, selectのみ)
			 * trueにすると元の要素番号のまま表示します。
			 * 
			 * @prop {string | function} jump 次のページのアンケートIDを指定（必須）
			 * 固有の条件を追加したい場合はfunctionを指定してください。ここで実行せず関数名のみを記入してください。
			 * 引数には回答結果(result)が渡されます（具体的な書き方はthis.npsBranchを参考にしてください）。
			 * 
			 * @prop {array[string]} together
			 * 同じページに同時に表示したいアンケートがあれば配列にIDを記入してください。
			 * ここで指定するアンケートにはjumpは設定しないでください。
			 *  
			 * @prop {boolean} required
			 * 回答が必須かどうか
			 * 
			 * @prop {boolean} result
			 * 回答結果が格納されます。
            */
			questions: { 

				nps_rating: { //ID
					title: '当店のサービスを友人や同僚に薦める可能性はどれぐらいでしょうか？', //質問
					progress: '0%', //回答率
					type: 'nps', //アンケートのタイプ
					options: 10, //アンケートの選択肢
					jump: this.npsBranch, //次のページを指定
					// together: [], //同じページに同時に表示したいアンケート
					required: true, //必須かどうか
					result: '', //回答結果
				},

				general_bad: {
					title: '本日、当店で最も良くなかったと感じられた点を以下からお選びください。',
					progress: '20%',
					type: 'radio',
					randomize: true,
					options: [
						{ val: '従業員の態度が悪かった', jump: 'bad_staff' },
						{ val: '商品の買いやすさ（食券機）', jump: 'stressful_when_buying' },
						{ val: '設備や食器の汚れ、破損が気になった', jump: 'bad_facilities' },
						{ val: '商品の提供や注文の確認が遅かった', jump: 'moment_long_waiting' },
						{ val: '商品が期待はずれだった', jump: 'bad_item' },
						{ val: '店内の環境が不快に感じた', jump: 'bad_environment' },
						{ val: '衛生面で不安を感じた', jump: 'to_improve' },
						{ val: '上記のいずれでもない', jump: 'to_improve', excludeRandomize: true },
					],
					required: true,
					result: '',
				},

				bad_staff: {
					title: '従業員についてもっとも気になった点を一つ教えてください。',
					progress: '40%',
					type: 'radio',
					randomize: true,
					options: [
						{ val: '従業員の衛生観念の低さ' },
						{ val: 'かけ声がうるさく感じた' },
						{ val: '活気がなかった' },
						{ val: '従業員間のおしゃべりが気になった' },
						{ val: '接客態度が悪かった' },
					],
					jump: 'to_improve',
					required: true,
					result: '',
				},

				stressful_when_buying: {
					title: '購入時に最もストレスを感じた項目を、以下の中から一つお選びください。',
					progress: '40%',
					type: 'radio',
					randomize: true,
					options: [
						{ val: '券売機が故障していた' },
						{ val: 'キャッシュレス決済が使えなかった' },
						{ val: '券売機前に行列ができており、購入までに時間がかかった' },
						{ val: '券売機の操作がわかりにくかった' },
						{ val: '従業員の説明が不足していた' },
					],
					jump: 'to_improve',
					required: true,
					result: '',
				},

				bad_facilities: {
					title: '建物や設備について最も気になった点を一つお選びください。',
					progress: '40%',
					type: 'radio',
					randomize: true,
					options: [
						{ val: '厨房が清掃されていない' },
						{ val: '駐車場が清掃されていない' },
						{ val: '店舗の入り口がわかりにくい' },
						{ val: '食器が汚れていた' },
						{ val: '客席が清掃されていない' },
						{ val: 'トイレが清掃されていない' },
						{ val: '駐車しにくい' },
						{ val: '上記のいずれでもない', excludeRandomize: true },
					],
					jump: 'to_improve',
					required: true,
					result: '',
				},

				moment_long_waiting: {
					title: '最も長く待たされたと感じたのはどの時でしたか？',
					progress: '40%',
					type: 'radio',
					randomize: true,
					options: [
						{ val: '券売機で食券を買うまで' },
						{ val: '商品が提供されるまで' },
						{ val: 'ご注文の確認時' },
						{ val: '用事があり、従業員に呼びかけた時' },
						{ val: '来店から着席まで' },
						{ val: '上記のいずれでもない', excludeRandomize: true },
					],
					jump: 'to_improve',
					required: true,
					result: '',
				},

				bad_item: {
					title: 'お食事されたもののうち、主にどの商品に不満を感じられましたか？',
					progress: '40%',
					type: 'radio',
					randomize: true,
					options: [
						{ val: 'ラーメン（レギュラーメニュー)' },
						{ val: 'ラーメン（期間限定商品）' },
						{ val: '餃子' },
						{ val: 'ライス・丼物' },
						{ val: 'トッピング' },
						{ val: 'ドリンク' },
					],
					jump: 'bad_quality',
					required: true,
					result: '',
				},

				bad_quality: {
					title: 'ご期待に添えなかった理由のうち、最も当てはまるもの一つをお選びください。',
					progress: '50%',
					type: 'radio',
					randomize: true,
					options: [
						{ val: '味が薄すぎる' },
						{ val: '辛すぎる' },
						{ val: '品質が悪い' },
						{ val: '熱すぎる' },
						{ val: '味が濃すぎる' },
						{ val: '脂が多すぎる' },
						{ val: 'ぬるい' },
						{ val: '指定したお好み通りに調理されていない' },
						{ val: '希望した商品と違うものが提供された' },
						{ val: '上記のいずれでもない', excludeRandomize: true },
					],
					jump: 'to_improve',
					required: true,
					result: '',
				},

				bad_environment: {
					title: '店内の環境について、最も気になった点を一つだけお選びください。',
					progress: '40%',
					type: 'radio',
					randomize: true,
					options: [
						{ val: '暑すぎた' },
						{ val: '寒すぎた' },
						{ val: '暗すぎた' },
						{ val: '明るすぎた' },
						{ val: '従業員のかけ声がうるさかった' },
						{ val: 'BGMがうるさかった' },
					],
					jump: 'to_improve',
					required: true,
					result: '',
				},

				general_good: {
					title: '本日、当店の最も良かった点を一つだけお選びください。',
					progress: '30%',
					type: 'radio',
					randomize: true,
					options: [
						{ val: 'レギュラー商品が美味しかった', jump: 'good_item' },
						{ val: '期間限定商品が美味しかった', jump: 'good_item' },
						{ val: 'トッピング・サイドメニューが美味しかった', jump: 'good_menu' },
						{ val: '従業員のサービス・対応が良かった', jump: 'good_staff' },
						{ val: '店舗が清潔に保たれていた' },
						{ val: '深夜・早朝でも営業していた' },
						{ val: '駐車場が広く、来店しやすかった' },
						{ val: 'キャッシュレス決済(電子マネーなど)が使えた' },
						{ val: '上記のいずれでもない', excludeRandomize: true },
					],
					jump: 'to_improve',
					required: true,
					result: '',
				},

				good_item: {
					title: '商品で、最も良かった点を一つお選びください。',
					progress: '40%',
					type: 'radio',
					randomize: true,
					options: [
						{ val: '麺' },
						{ val: 'スープ' },
						{ val: 'チャーシュー' },
						{ val: '総合的なバランス' },
						{ val: '上記のいずれでもない', excludeRandomize: true },
					],
					jump: 'to_improve',
					required: true,
					result: '',
				},
				
				good_menu: {
					title: '最も美味しかったと思われるメニューはどちらですか？',
					progress: '40%',
					type: 'radio',
					randomize: true,
					options: [
						{ val: 'ミニ丼' },
						{ val: 'トッピング' },
						{ val: '餃子' },
						{ val: 'ライス' },
						{ val: 'ドリンク類' },
						{ val: '上記のいずれでもない', excludeRandomize: true },
					],
					jump: 'to_improve',
					required: true,
					result: '',
				},

				good_staff: {
					title: '当店従業員の最も良かった点を教えてください。',
					progress: '40%',
					type: 'radio',
					randomize: true,
					options: [
						{ val: '接客の丁寧さ' },
						{ val: '対応のスピーディーさ' },
						{ val: '元気の良さ' },
						{ val: '親切さ' },
						{ val: '調理の手際' },
						{ val: 'その他 (具体的に)', textbox: '', excludeRandomize: true },
					],
					jump: 'to_improve',
					required: true,
					result: '',
				},

				to_improve: {
					title: 'よりよい評価をいただくために、当店が最優先で取り組むべき項目を教えてください。',
					progress: '60%',
					type: 'radio',
					randomize: true,
					options: [
						{ val: '商品の質の向上' },
						{ val: '従業員の質の向上' },
						{ val: '設備の改善' },
						{ val: '清掃の強化' },
						{ val: 'その他 (具体的に)', textbox: '', excludeRandomize: true },
					],
					jump: 'frequency_of_visits_brand',
					required: true,
					result: '',
				},

				frequency_of_visits_brand: {
					title: '当店または他の「ラーメン山岡家」「極煮干し本舗」「味噌ラーメン山岡家」のご利用頻度を教えてください。',
					progress: '80%',
					type: 'radio',
					options: [
						{ val: 'はじめての来店' },
						{ val: '2回目の来店' },
						{ val: '10回未満' },
						{ val: '年に1-2回程度利用する' },
						{ val: '月に1-2回程度利用する' },
						{ val: '週に1回程度利用する' },
						{ val: '週に2回以上利用する ' },
					],
					jump: 'age',
					required: true,
					result: '',
				},

				age: {
					title: 'あなたの年齢と性別を教えてください。（任意）',
					subtitle: 'あなたの年齢は？',
					progress: '90%',
					type: 'select',
					options: [
						{ val: '20歳未満' },
						{ val: '20～24歳' },
						{ val: '25～29歳' },
						{ val: '30～39歳' },
						{ val: '40～49歳' },
						{ val: '50～59歳' },
						{ val: '60歳以上' },
					],
					together: ['sex'],
					jump: 'completed',
					required: false,
					result: '',
				},

				sex: {
					subtitle: 'あなたの性別は？',
					type: 'select',
					options: [
						{ val: '男性' },
						{ val: '女性' },
					],
					required: false,
					result: '',
				},
			},

			currentPage: 'nps_rating', //現在のページ
			startDate: new Date(), //vueインスタンス作成時点の日付オブジェクト
			errors: {}, //エラーメッセージ
			route: [], //辿ってきたルート
			result: {} //回答結果
		}
	},

	computed: {
		/**
		 * @return {array} 現在のページに表示する質問
		 * currentPageと一致するIDのアンケートを返します。また、そのアンケートにtogetherが設定されていれば、追加して返します。
		*/
		currentQuestions() {
			let currentQuestions = [this.questions[this.currentPage]];
			// 同じページに表示する質問があれば追加
			if ('together' in currentQuestions[0]) {
				for (let together of currentQuestions[0].together) {
					currentQuestions.push(this.questions[together]);
				}
			}
			return currentQuestions;
		},

		// アンケートの番号
		surveyNum() {
			const num = this.route.length + 1; //辿ってきた質問+1
			return ('00' + num).slice(-2); //ゼロパディング
		},

		/**
		 * @return {boolean} 最後のページ(jumpの値が'completed')であればtrueを返す
		 */
		isLastPage() {
			if (this.currentQuestions[0].jump === 'completed') return true;
		}
	},

	methods: {
		/** ラジオボタンとテキストボックスを連動させる
		 * @param event DOMイベント($event)
		 * @param {string} id 連動させるフォーム部品のID
		 * @param {object} question 現在の質問（イベントの発火がテキストボックスの場合に、連動するラジオボタンの値を格納するために使用します。イベントの発火がラジオボタンの場合は必要ありません。）
		*/
		connectText(event, id, question = null) {
			const type = event.target.getAttribute('type');
			const target = document.getElementById(id);

			// イベントの発火がラジオボタン：テキストボックスをフォーカス
			if (type === 'radio') {
				target.focus();

			// イベントの発火がテキストボックス：ラジオボタンをチェック
			} else if (type === 'text') {
				const radioList = document.querySelectorAll('input[type="radio"]');
				for (const radio of radioList) radio.checked = false; //一旦全てのチェックを外す
				target.checked = true;
				question.result = target.value; //ラジオボタンの値をresultに格納
			}
		},

		// 前のページへ
		back() {
			const jump = this.route.pop(); //前のページを取得＆ルートを削除

			//前のページの回答結果を削除
			let deleteIds = [jump];
			if ('together' in this.questions[deleteIds[0]]) {
				deleteIds = deleteIds.concat(this.questions[deleteIds[0]].together);
			}
			for (let id of deleteIds) {
				delete this.result[id];
			}

			this.errors = {}; //エラーを初期化
			this.currentPage = jump; //前のページに移動
			this.$emit('progress', this.currentQuestions[0].progress); //回答率を親コンポーネントに送信
		},

		/**
		 * 次のページへ遷移
		 * バリデーション、回答結果の保存も同時に行います。
		*/
		next() {
			this.checkForm(); //バリデーション
			if (Object.keys(this.errors).length) return; //バリデーションに引っかかったら終了

			let next; //次のページ
			for (let question of this.currentQuestions) {
				const id = question.id; //アンケートID
				const options = question.options; //アンケートの選択肢
				const jump = question.jump; //次のページ
				const result = question.result; //回答結果
	
				this.setResult(id, options, result); //回答結果を保存
				next = this.getNextPage(jump, options, result); //次ページの設定
			}

			// 最後のページではない場合
			if (this.currentQuestions[0].jump != 'completed') {
				this.route.push(this.currentPage); //現在のページを保存（戻れるようにするため）
				this.currentPage = next; //次のページに移動
				this.$emit('progress', this.currentQuestions[0].progress); //回答率を親コンポーネントに送信
				// console.log(this.result);
				// console.log(this.route);

			// 最後のページの場合
			} else {
				this.emitResult(); //親コンポーネントに回答結果を送信
			}
		},

		/**
		 * バリデーション
		 * エラーがあればthis.errorsにエラーメッセージを格納します。
		*/
		checkForm() {
			this.errors = {}; //エラーを初期化

			for (let question of this.currentQuestions) {
				const id = question.id; //アンケートID
				const options = question.options; //アンケートの選択肢
				const required = question.required; //必須かどうか
				const result = question.result; //回答結果

				// 必須項目が選択されていない場合
				if (required && !result) {
					const str = 'この質問は必須回答です。';
					this.pushError(id, str);
				}
	
				// 選択肢が配列の場合（ラジオボタン・セレクトボックス）
				if (Array.isArray(options)) {
					const resultOption = options.find((option) => option.val === result); //回答に選ばれた選択肢

					// 「その他」のテキストボックス
					if (resultOption && 'textbox' in resultOption) {

						// テキストが空の場合
						if (!resultOption.textbox) {
							const str = 'コメントを入力してください。';
							this.pushError(id, str);
						}

						// 文字数制限
						const text = this.h(resultOption.textbox);
						if (text.length > 150) {
							const str = 'もう少し短く記入してください。';
							this.pushError(id, str);
						}
					}
				}
			}
		},

		/**
		 * エラーメッセージを格納
		 * @param {string} id アンケートID
		 * @param {string} str エラーメッセージ
		*/
		pushError(id, str) {
			if ([id] in this.errors === false) this.errors[id] = []; //アンケートIDのプロパティを作成
			this.errors[id].push(str);
		},

		// 特殊文字をサニタイズ
		h(text) {
			return text.replace(/&/g, '&lt;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, "&#x27;");
		},

		/**
		 * 回答結果を保存
		 * @param {String} id アンケートID
		 * @param {Array} options アンケートの選択肢
		 * @param {String} result 回答結果
		 * */
		setResult(id, options, result) {
			if (result) {
				this.result[id] = result; 
			} else {
				this.result[id] = null;
			}

			// 選択肢が配列の場合（ラジオボタン・セレクトボックス）
			if (Array.isArray(options)) {
				const resultOption = options.find((option) => option.val === result); //回答に選ばれた選択肢

				// 回答にテキストボックスがあれば回答結果に追加
				if (resultOption && 'textbox' in resultOption) {
					this.result[id] += ` ${this.h(resultOption.textbox)}`;
				}
			}
		},

		/**
		 * 次のページを取得
		 * @param {String} jump アンケートオブジェクト直下に設定されている次のページ
		 * @param {Array} options アンケートの選択肢
		 * @param {String} result 回答結果
		 * @return {String} 次のページのアンケートID
		 * */
		getNextPage(jump, options, result) {
			let next;

			if (jump) {
				next = jump; //次のページをセット
				if (typeof jump === 'function') next = jump(result); //関数の場合実行(引数に回答結果を渡す)
			}

			// 選択肢が配列の場合（ラジオボタン・セレクトボックス）
			if (Array.isArray(options)) {
				const resultOption = options.find((option) => option.val === result); //回答に選ばれた選択肢

				// jumpが存在すれば次のページを上書き
				if (resultOption && 'jump' in resultOption) {
					next = resultOption.jump;
				}
			}

			return next;
		},

		// 回答結果を親コンポーネントに渡す
		emitResult() {
			this.setAnswerTime();
			this.$emit('submit', this.result);
		},

		// 回答時間（秒）を保存
		setAnswerTime() {
			const now = Math.round(new Date().getTime() / 1000);
			const start = Math.round(this.startDate.getTime() / 1000);
			this.result.answer_time = (now - start);
		},

		/**
		 * 多段階評価の分岐
		 * @param {number} result アンケートの回答結果
		 * @return {string} 遷移先のアンケートID
		*/
		npsBranch(result) {
			if (!result) return;

			if (result <= 5) { //0~5
				return 'general_bad';
			} else if (result <= 7) { //6~7
				return 'to_improve';
			} else { //8~10
				return 'general_good';
			}
		},

		/** 選択肢をランダマイズ
		 * @param {string} id アンケートID
		*/
		randomizeOptions(id) {
			if (!this.questions[id].randomize) return;

			const options = this.questions[id].options; //アンケートの選択肢

			// 除外する要素を抽出
			let exclude = {};
			for (let i = 0, len = options.length; i < len; ++i) {
				if (!options[i].excludeRandomize) continue;
				exclude[i] = options.splice(i, 1)[0];
			}

			this.questions[id].options = this.shuffleArray(options); //ランダマイズ

			// 除外した要素を元に戻す
			for (let num in exclude) {
				if (exclude.hasOwnProperty(num)) {
					this.questions[id].options.splice(num, 0, exclude[num]);
				}
			}
		},

		// 配列の要素の順番をランダムに入れ替える
		shuffleArray(array) {
			for (let i = 0; i < array.length; i++) {
				let rand = Math.floor(Math.random() * (i + 1));
				let tmpStorage = array[i];
				array[i] = array[rand];
				array[rand] = tmpStorage;
			}
			return array;
		},
	},

	created() {
		// アンケートデータの加工
		for(let id in this.questions) {

			// 質問のオブジェクトにIDプロパティを追加
			if( this.questions.hasOwnProperty(id) ) {
				this.questions[id].id = id;
			}

			// 選択肢をランダムに入れ替える
			this.randomizeOptions(id);
		}
	},

	watch: {
		// ページが切り替わったらスクロールを最上部へ
		currentPage() {
			const container = document.querySelector('.js-container');
			container.scrollTo({top: 0});
		},
	}
}
</script>